import { MultiCodeBlock } from "@imgly-labs/gatsby-theme-imgly-docs";
import * as React from 'react';
export default {
  MultiCodeBlock,
  React
};